import React from 'react';
import useCondition from '../../useCondition';
import Header from '../Header';
import Footer from './Footer';

const InflowDateFilter = () => {
  const {condition, setCondition} = useCondition();

  const onChangeFrom = (e: React.ChangeEvent<HTMLInputElement>) =>
    setCondition({inflowDateFrom: e.target.value});

  const onChangeTo = (e: React.ChangeEvent<HTMLInputElement>) =>
    setCondition({inflowDateTo: e.target.value});

  const onChangeType = (e: React.ChangeEvent<HTMLInputElement>) =>
    setCondition({inflowDateType: e.target.value});

  return (
    <>
      <Header title="流入日" />
      <div className="p-6 bg-c-bg flex-1 flex flex-col gap-4 rounded-b overflow-y-scroll">
        <div className="bg-white p-6 rounded flex flex-col gap-2">
          <div className="flex flex-col mb-6 border-b border-[#E1E6EB] pb-5">
            <div className="flex items-center gap-1">
              <input
                type="radio"
                value="latest"
                name="type"
                id="latest"
                onChange={onChangeType}
                checked={condition.inflowDateType === 'latest'}
              />
              <label htmlFor="latest">最新</label>
            </div>
            <div className="flex items-center gap-1">
              <input
                type="radio"
                value="original"
                name="type"
                id="original"
                onChange={onChangeType}
                checked={condition.inflowDateType === 'original'}
              />
              <label htmlFor="original">初回</label>
            </div>
          </div>
          <div className="flex items-center gap-4">
            <input
              type="date"
              value={condition.inflowDateFrom ?? ''}
              max={condition.inflowDateTo}
              onChange={onChangeFrom}
              className="form-input appearance-none w-32 bg-white border-c-lighter px-2 py-2 rounded leading-normal focus:outline-none text-sm text-c-light disabled:bg-c-bg disabled:text-c-light"
            />
            <span>~</span>
            <input
              type="date"
              min={condition.inflowDateFrom}
              value={condition.inflowDateTo ?? ''}
              onChange={onChangeTo}
              className="form-input appearance-none w-32 bg-white border-c-lighter px-2 py-2 rounded leading-normal focus:outline-none text-sm text-c-light disabled:bg-c-bg disabled:text-c-light"
            />
          </div>
        </div>
      </div>
      <Footer
        onClear={() =>
          setCondition({
            inflowDateFrom: null,
            inflowDateTo: null,
            inflowDateType: 'latest',
          })
        }
      />
    </>
  );
};

export default InflowDateFilter;
